export type SequencerPresentation = 'music' | 'history' | 'default';

export function resolveSequencerPresentation(subjectTag?: string): SequencerPresentation {
  const tag = String(subjectTag || '').toLowerCase();
  if (tag === 'musica' || tag === 'music') return 'music';
  if (tag === 'historia' || tag === 'history' || tag.includes('histor')) return 'history';
  return 'default';
}

export function sequencerDefaultPrompt(presentation: SequencerPresentation): string {
  switch (presentation) {
    case 'music':
      return 'Ordena las figuras rítmicas para completar el compás.';
    case 'history':
      return 'Ordena cronológicamente los eventos.';
    default:
      return 'Ordena los elementos en la secuencia correcta.';
  }
}

export function sequencerOrderInstruction(
  presentation: SequencerPresentation,
  itemCount: number,
): string {
  const n = Math.max(1, itemCount);
  switch (presentation) {
    case 'music':
      return `Escribe el número del orden correcto (1 al ${n}) en el casillero para completar el compás:`;
    case 'history':
      return `Escribe el número del orden cronológico (1 al ${n}) en el casillero:`;
    default:
      return `Escribe el número del orden correcto (1 al ${n}) en el casillero.`;
  }
}

/** Indicador visual del paso en la línea de tiempo / lista. */
export function sequencerStepMarker(
  presentation: SequencerPresentation,
  position: number,
): string {
  switch (presentation) {
    case 'music':
      return '♩';
    case 'history':
      return '◉';
    default:
      return String(position + 1);
  }
}

export function sequencerStudentHint(presentation: SequencerPresentation): string {
  switch (presentation) {
    case 'music':
      return 'Arrastra con las flechas · ordena las figuras del compás';
    case 'history':
      return 'Arrastra con las flechas · ordena los eventos en el tiempo';
    default:
      return 'Arrastra con las flechas · ordena de arriba a abajo';
  }
}

export function sequencerTimelineLabel(presentation: SequencerPresentation): string {
  switch (presentation) {
    case 'music':
      return 'Línea de tiempo · secuencia rítmica correcta';
    case 'history':
      return 'Línea de tiempo · secuencia cronológica correcta';
    default:
      return 'Línea de tiempo · secuencia correcta';
  }
}
